import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "programs-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "program-card current" }
const _hoisted_4 = { class: "cta" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "cta-buttons" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

// About view - static content

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _cache[10] || (_cache[10] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("div", { class: "hero-content" }, [
        _createElementVNode("h2", null, "About Space Coast STEM")
      ])
    ], -1)),
    _cache[11] || (_cache[11] = _createElementVNode("section", { class: "content-section" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("h2", null, "What We Do"),
        _createElementVNode("p", null, " We provide refurbished computers and laptops to students in need across Brevard County, helping bridge the digital divide and ensuring every student has access to the technology they need for their education. ")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Our Programs", -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "program-badge" }, "Current Focus", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Laptop Program", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, " Our primary focus is providing refurbished laptops to students who need them. We handle donations, sourcing, and refurbishment so teachers can focus on identifying students in need, and getting devices into their hands. ", -1)),
          _createVNode(_component_router_link, {
            to: "/theplan",
            class: "program-link"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Learn About The Plan →", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"future-programs\" data-v-755d692a><h3 data-v-755d692a>Future Programs</h3><p data-v-755d692a> As we continue to grow, we hope to build industry partnerships and expand our offerings to include:</p><br data-v-755d692a><ul data-v-755d692a><li data-v-755d692a><strong data-v-755d692a>Coding Workshops</strong> - Hands-on programming workshops for students of all skill levels</li><li data-v-755d692a><strong data-v-755d692a>STEM Mentorship</strong> - Connecting students with professionals in STEM fields</li><li data-v-755d692a><strong data-v-755d692a>Hackathons &amp; Competitions</strong> - Events where students can collaborate, innovate, and showcase their skills</li><li data-v-755d692a><strong data-v-755d692a>Robotics &amp; Maker Spaces</strong> - Access to tools and mentorship for robotics, electronics, and 3D printing</li></ul></div>", 1))
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Join Our Mission", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", null, "Together, we can ensure every student has the tools they need to succeed", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/get-involved",
            class: "btn btn-primary"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Get Involved", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "btn btn-secondary"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Contact Us", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})